<template>
  <normal-dialog
    title="配置设备"
    :visible="visible"
    :before-close="resetDialog"
    @update:visible="updateVisibleHandle"
    width="70vw"
  >
    <div
      class="DeviceList"
      v-loading="loading"
    >
      <div class="DeviceList-Title">
        <div class="DeviceList-Title-item">所属区域: {{selected.campusName}}</div>
        <div class="DeviceList-Title-item">时间设置编号: {{selected.code}}</div>
        <div class="DeviceList-Title-item">时间设置名称: {{selected.name}}</div>
      </div>
      <ks-transfer
        :list="[...allDeviceList,...selected.originList]"
        v-model="selected.deviceList"
        :mapProps="{key: 'deviceCode', label: 'text'}"
        :onChange="submitUpdateHandle"
        @close="resetDialog"
      ></ks-transfer>
    </div>
  </normal-dialog>
</template>

<script>
const dialogMixin = manageShell.default.mixinModule.Dialog;

export default {
  props: {
    allDeviceList: { type: Array },
    addTimeItem: { type: Function },
  },
  mixins: [dialogMixin],
};
</script>


<style lang="scss">
.DeviceList {
  .DeviceList-Title {
    display: flex;
    .DeviceList-Title-item {
      margin-right: 20px;
    }
  }
}
</style>
